import { makeStyles } from '@material-ui/core/styles';

import { COLOR } from 'assets/styles/colors';

export const useStyles = makeStyles((theme) => ({
  formControl: {
    width: 240,
    '& label': {
      fontSize: 16,
      lineHeight: '13px',
      color: COLOR.GREY_2,
    },

    '& fieldset span': {
      marginRight: 15,
    },

    '& .MuiOutlinedInput-input': {
      boxSizing: 'border-box',
      padding: '10px 14px',
      height: 36,
    },

    '& .MuiInputBase-input': {
      fontSize: 16,
    },

    '& .MuiOutlinedInput-root': {
      borderRadius: 6,
      fontSize: 16,
      color: COLOR.GREY_2,
    },

    '& .MuiSelect-select.Mui-disabled': {
      background: 'rgba(217, 218, 222, 0.3)',
    },

    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: COLOR.BLUE_1,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: `2px solid ${COLOR.GREY_1}`,
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: COLOR.GREY_1,
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 80%) scale(1)',

      '&.MuiInputLabel-shrink': {
        fontSize: '16px !important',
        transform: 'translate(14px, -6px) scale(0.9)',
      },
    },
    // Table-Notebook
    [theme.breakpoints.up('md')]: {
      '& .MuiOutlinedInput-input': {
        height: 40,
        padding: '13px 14px',
      },
      '& label, & .MuiInputBase-input': {
        fontSize: 18,
      },
      '& fieldset span': {
        marginRight: 62,
      },
    },
    // Desktop
    [theme.breakpoints.up('lg')]: {
      '& .MuiInputBase-input': {
        fontSize: 20,
      },
    },
  },
}));
